const USER_INTENT_EVENTS = ['mousemove', 'touchstart', 'keydown'];

async function loadHeavyScripts() {
  const [
    { default: Tracking },
    { initTarteAuCitron },
    { initZendesk },
    { initKlaviyo },
  ] = await Promise.all([
    import('./utils/Tracking'),
    import('./tarteaucitron'),
    import('./zendesk'),
    import('./klaviyo'),
  ]);

  Tracking.init();

  if (window.__loadTarteAuCitron) {
    window.__loadTarteAuCitron();
    initZendesk();
  }

  initTarteAuCitron();
  initKlaviyo();
}

export const initLazyLoading = () => {
  let isLoaded = false;

  const trigger = () => {
    if (isLoaded) {
      return;
    }

    isLoaded = true;

    const runner = () => {
      loadHeavyScripts().catch(error => {
        console.error('Failed to load deferred scripts', error);
      });
    };

    if ('requestIdleCallback' in window) {
      requestIdleCallback(runner);
    } else {
      setTimeout(runner, 1);
    }
  };

  USER_INTENT_EVENTS.forEach(evt => {
    window.addEventListener(evt, trigger, { passive: true, once: true });
  });
};
